(function () {
  "use strict";

  /* ============================================================
     MINI POTE — produto EXCLUSIVO da LP (06/Ago/2026)

     Regra de negócio:
       Os produtos de MINI POTE só podem ser comprados ESTANDO na
       /pages/lp-mini-pote. Em QUALQUER outra página (home, PDP, coleção,
       busca, carrinho), as linhas de mini pote saem do carrinho.

     Por quê:
       Os 6 produtos de mini pote são UNLISTED (tags hide-collection /
       no-discount) e ficam fora de busca, coleção e sitemap — mas seguem
       COMPRÁVEIS POR LINK DIRETO na PDP. O combo de R$458,70 passa do
       gatilho de R$384,90 da regra do Vex e destrava o Sérum La Roche num
       combo que não deveria ganhar brinde (ticket G195044, pedido G195044).

     Por que a regra mora aqui e não no app:
       O Vex: Auto Add To Cart NÃO tem exclusão por produto/tag — verificado
       no painel da regra "Sérum Roche-Posa - GRATIS": os únicos filtros são
       cliente (segmentação), país (geotargeting), horário (schedule) e
       limite de uso. Não há campo de excluir produto.

     Por que NÃO mexemos no Sérum diretamente:
       Removendo a linha do mini pote, o subtotal cai abaixo de R$384,90 e o
       PRÓPRIO VEX recolhe o brinde. Mexer no sérum entraria em corrida com a
       opção "Prevent customer from changing the quantity/removing" que está
       MARCADA na regra do app — guerra de scripts (app repõe, guard remove).

     Remoção CIRÚRGICA:
       Só as linhas de mini pote saem. Todo o resto do carrinho (creatina,
       melatonina, sérum, Kit XP) permanece intacto. Nunca /cart/clear.

     Comportamentos não-óbvios:
       - Intercepta window.fetch e XMLHttpRequest: cobre TODOS os caminhos de
         adição de uma vez (PDP, order bump do drawer, pop-ups ups-*.js, Vex,
         apps de terceiros) em vez de tentar mapear cada botão.
       - Só /cart/add dispara: change/update são o próprio guard agindo e
         re-disparar causaria laço.
       - product_id (não variant_id): sobrevive a variantes novas criadas
         depois no admin.
       - O CHECKOUT não é afetado: ele vive em /checkouts/cn/... e NÃO carrega
         o theme.liquid — nenhum asset do tema roda lá (verificado em
         06/Ago/2026: 0 assets do tema no HTML do checkout). Quem finalizou
         pela LP fecha o pedido normalmente.
       - O Kit Experimentação (10245392400693) NÃO entra aqui: tem LP e guard
         próprios (kit-exclusivo-guard.js).
       - O tema redesenha a gaveta do carrinho a cada mudança (reinjeta o
         conteúdo em #halo-cart-sidebar .previewCart-wrapper) → o toast é
         re-injetado via MutationObserver.

     PORTE PARA O TEMA NOVO (21/Ago/2026): o tema antigo usava o carrinho do app
     Kaching, que não existe aqui. A REGRA (ler /cart.js, remover com
     /cart/change.js, interceptar fetch/XHR) não mudou uma linha. Mudou só a
     parte visual:
       • toast: encaixa em #halo-cart-sidebar .halo-sidebar-wrapper (vem do
         Liquid, sempre no DOM) em vez de .kaching-cart__contents;
       • redesenho: window.sharedFunctions.updateSidebarCart(cart) — o MESMO
         redesenho que o window.updateCart() do tema faz, mas SEM abrir a gaveta;
       • supressão da gaveta: REMOVIDA (ver bloco REMOÇÃO SILENCIOSA abaixo).

     Rollback: remover a linha do theme.liquid.
     ============================================================ */

  try {
    if (window.__GD_MINIPOTE_GUARD_LOADED) return;
    window.__GD_MINIPOTE_GUARD_LOADED = true;

    /* ======================== CONFIG ======================== */

    // Handle da LP onde o mini pote PODE ser comprado.
    var LP_HANDLE = "lp-mini-pote";

    // Os 6 produtos de mini pote publicados (auditoria do catálogo 06/Ago/2026,
    // via Admin API: title:*mini* OR title:*pote*). Todos UNLISTED e compráveis
    // por link direto. product_id em String pra casar com o /cart.js sem
    // depender de tipo.
    var MINIPOTE_PRODUCT_IDS = [
      "10584158175541", // Combo 3 creatinas + mini potes (Oakberry/MV/FV) R$458,70
      "10586330431797", // Combo 2 creatinas + mini potes (MV/FV)          R$323,80
      "10584122360117", // Mini pote — Frutas Vermelhas                    R$ 19,90
      "10584124883253", // Mini pote — Limão                               R$ 19,90
      "10584133566773", // Mini pote — Maçã Verde                          R$ 19,90
      "10584187011381", // Mini pote — Oakberry Açaí                       R$ 19,90
    ];

    var TOAST_ID = "gd-minipote-toast";
    var STYLE_ID = "gd-minipote-guard-css";

    var MSG_REMOVED =
      "<b>Oferta exclusiva da página.</b> Os mini potes só podem ser comprados pela página da oferta — os outros itens do seu carrinho foram mantidos.";

    var ROOT =
      (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) ||
      "/";

    /* ======================== CSS ======================== */

    function injectCSS() {
      if (document.getElementById(STYLE_ID)) return;
      var css =
        "#" +
        TOAST_ID +
        "{display:flex;align-items:flex-start;gap:8px;" +
        "margin:0 16px 10px;padding:10px 12px;background:#FFF6E5;border:1px solid #F2D9A8;" +
        "border-left:3px solid #E8A33D;border-radius:8px;font-size:12.5px;color:#6B4A12;" +
        "line-height:1.45;animation:gd-mp-in .35s cubic-bezier(.22,.8,.35,1);}" +
        "@keyframes gd-mp-in{from{opacity:0;transform:translateY(-6px)}to{opacity:1;transform:none}}" +
        "#" +
        TOAST_ID +
        " .gd-mp-ico{flex-shrink:0;font-size:14px;line-height:1.2;}" +
        "#" +
        TOAST_ID +
        " .gd-mp-txt{flex:1;}" +
        "#" +
        TOAST_ID +
        " .gd-mp-txt b{color:#4A330A;}" +
        "#" +
        TOAST_ID +
        " .gd-mp-x{background:none;border:0;cursor:pointer;color:#8a6a30;" +
        "font-size:15px;line-height:1;padding:0 2px;}";
      var st = document.createElement("style");
      st.id = STYLE_ID;
      st.textContent = css;
      document.head.appendChild(st);
    }

    /* ======================== TOAST ======================== */

    // Mensagem pendente: sobrevive ao redesenho da gaveta até ser exibida.
    var pendingMsg = null;

    // .halo-sidebar-wrapper vem do Liquid (halo-cart-sidebar.liquid) e está SEMPRE
    // no DOM, gaveta aberta ou fechada. O conteúdo (.previewCart-wrapper) é
    // reescrito pelo tema a cada redesenho — encaixando o toast no wrapper, e não
    // dentro do conteúdo, ele sobrevive a isso.
    function mountToast() {
      if (!pendingMsg) return;
      var drawer =
        document.querySelector("#halo-cart-sidebar .halo-sidebar-wrapper") ||
        document.querySelector("#halo-cart-sidebar");
      if (!drawer) return; // gaveta ainda não montada: espera
      if (document.getElementById(TOAST_ID)) return;

      var el = document.createElement("div");
      el.id = TOAST_ID;
      el.setAttribute("role", "status");
      el.innerHTML =
        '<span class="gd-mp-ico">ℹ️</span>' +
        '<span class="gd-mp-txt">' +
        pendingMsg +
        "</span>" +
        '<button class="gd-mp-x" type="button" aria-label="Fechar aviso">✕</button>';
      drawer.insertBefore(el, drawer.firstChild);

      el.querySelector(".gd-mp-x").addEventListener("click", function () {
        pendingMsg = null;
        if (el.parentNode) el.parentNode.removeChild(el);
      });
    }

    function notify(msg) {
      pendingMsg = msg;
      mountToast();
    }

    /* ======================== HELPERS ======================== */

    // Estamos na LP? O que importa é onde o cliente está AGORA.
    // Match EXATO do path (tolerando barra final) — NÃO prefixo: com indexOf===0
    // uma página futura tipo /pages/lp-mini-pote-2 herdaria a isenção e viraria
    // rota de fuga da regra. A querystring não entra no pathname, então
    // ?utm_source=... continua funcionando.
    function isOnLP() {
      var p = String(window.location.pathname || "").replace(/\/+$/, "");
      return p === "/pages/" + LP_HANDLE;
    }

    function getCart() {
      return fetch(ROOT + "cart.js", { credentials: "same-origin" }).then(
        function (r) {
          return r.json();
        }
      );
    }

    function isMiniPoteLine(item) {
      return MINIPOTE_PRODUCT_IDS.indexOf(String(item.product_id)) !== -1;
    }

    // Remove SÓ as linhas de mini pote — /cart/change.js aceita id da LINHA.
    function removeMiniPoteLines(cart) {
      var lines = [];
      (cart.items || []).forEach(function (it, i) {
        if (isMiniPoteLine(it)) lines.push(i + 1); // change.js é 1-indexed
      });
      if (!lines.length) return Promise.resolve(false);

      // Remove de trás pra frente: tirar a linha 1 renumera as seguintes.
      var chain = Promise.resolve();
      lines
        .sort(function (a, b) {
          return b - a;
        })
        .forEach(function (line) {
          chain = chain.then(function () {
            return fetch(ROOT + "cart/change.js", {
              method: "POST",
              headers: {
                "Content-Type": "application/json",
                Accept: "application/json",
              },
              credentials: "same-origin",
              body: JSON.stringify({ line: line, quantity: 0 }),
            });
          });
        });
      return chain.then(function () {
        return true;
      });
    }

    /* REMOÇÃO SILENCIOSA (fix 06/Ago/2026 — reescrito no porte de 21/Ago/2026)
       Sintoma original: saindo da LP, o carrinho abria SOZINHO e vazio. Causa: o
       carrinho de uma LP pode ter UMA linha só — removendo-a o carrinho zera, e o
       Kaching (React) reagia à mutação abrindo a gaveta no estado vazio. A
       remoção tem que ser invisível: o cliente só deve perceber quando ABRIR o
       carrinho por conta própria.

       No tema novo o problema simplesmente não existe: a gaveta só abre quando
       alguém adiciona um produto ou clica no ícone do carrinho, nunca por reagir a
       uma mutação. Por isso toda a máquina de supressão (isDrawerOpen /
       closeDrawerQuietly / suppressDrawer) saiu — não há nada a suprimir.

       ⚠️ NÃO usar window.updateCart() aqui. Ele redesenha o carrinho, mas também
       adiciona 'cart-sidebar-show' no <body> (theme.js:240), ou seja ABRE a gaveta
       — exatamente o bug de 06/Ago de volta. Chamamos direto o
       sharedFunctions.updateSidebarCart, que é o mesmo redesenho sem o addClass.

       POR QUE redesenhar: se o cliente adicionou o produto FORA da LP, o tema abre
       a gaveta por conta do fluxo normal de adicionar, e ela mostraria a linha que
       acabamos de tirar. O redesenho corrige a tela e o contador do ícone
       ([data-cart-count], atualizado pelo próprio updateSidebarCart). */

    function refreshCartQuietly() {
      try {
        if (
          window.Shopify &&
          typeof window.Shopify.getCart === "function" &&
          window.sharedFunctions &&
          typeof window.sharedFunctions.updateSidebarCart === "function"
        ) {
          window.Shopify.getCart(function (cart) {
            try {
              window.sharedFunctions.updateSidebarCart(cart);
            } catch (e) {}
          });
        }
      } catch (e) {
        /* sem redesenho: a remoção já aconteceu no servidor, a tela se corrige no
           próximo carregamento. Nunca cai no updateCart() como plano B (abriria). */
      }
    }

    /* ======================== A REGRA ======================== */

    var enforcing = false;

    function enforce() {
      // Dentro da LP a oferta é legítima: não faz nada.
      if (isOnLP()) return Promise.resolve();
      if (enforcing) return Promise.resolve();
      enforcing = true;

      return getCart()
        .then(function (cart) {
          var items = (cart && cart.items) || [];
          if (!items.length) {
            enforcing = false;
            return;
          }

          var hasMini = items.some(isMiniPoteLine);
          if (!hasMini) {
            enforcing = false;
            return;
          }

          return removeMiniPoteLines(cart)
            .then(function (removed) {
              if (!removed) return;
              // Silêncio total: NÃO abrimos a gaveta. O toast fica PENDENTE e só
              // aparece quando o cliente abrir o carrinho por conta própria (o
              // MutationObserver monta na hora).
              notify(MSG_REMOVED);
              refreshCartQuietly();
            })
            .then(function () {
              enforcing = false;
            })
            .catch(function (e) {
              enforcing = false;
              console.warn("[MINIPOTE-GUARD] falha ao aplicar a regra:", e);
            });
        })
        .catch(function (e) {
          enforcing = false;
          console.warn("[MINIPOTE-GUARD] falha ao ler o carrinho:", e);
        });
    }

    /* ======================== INTERCEPTAÇÃO ======================== */

    // Só /cart/add dispara a regra: change/update são o próprio guard agindo
    // (ou a cliente mexendo em quantidade), e re-disparar causaria laço.
    function isAdd(url) {
      return url && /\/cart\/add(\.js)?(\?|$)/.test(String(url));
    }

    var origFetch = window.fetch;
    if (typeof origFetch === "function") {
      window.fetch = function (input, init) {
        var url = typeof input === "string" ? input : input && input.url;
        var p = origFetch.apply(this, arguments);
        if (isAdd(url)) {
          // Observa o resultado SEM consumir o body (só lê res.ok) e devolve a
          // Promise original intacta — o chamador (tema/app) segue lendo o
          // response normalmente. Um .then() aqui não clona nem trava o body.
          p.then(
            function (res) {
              if (res && res.ok)
                setTimeout(function () {
                  enforce();
                }, 60);
            },
            function () {
              /* erro de rede: nada a fazer */
            }
          );
        }
        return p;
      };
    }

    var origOpen = XMLHttpRequest.prototype.open;
    var origSend = XMLHttpRequest.prototype.send;
    XMLHttpRequest.prototype.open = function (method, url) {
      this.__gdMiniPoteUrl = url;
      return origOpen.apply(this, arguments);
    };
    XMLHttpRequest.prototype.send = function () {
      var xhr = this;
      if (isAdd(xhr.__gdMiniPoteUrl)) {
        xhr.addEventListener("load", function () {
          if (xhr.status >= 200 && xhr.status < 300) {
            setTimeout(function () {
              enforce();
            }, 60);
          }
        });
      }
      return origSend.apply(this, arguments);
    };

    /* ======================== OBSERVER (re-injeta o toast) ======================== */

    function observe() {
      var scheduled = false;
      var mo = new MutationObserver(function () {
        if (scheduled) return;
        scheduled = true;
        requestAnimationFrame(function () {
          scheduled = false;
          mountToast();
        });
      });
      mo.observe(document.body, { childList: true, subtree: true });
      window.__GD_MINIPOTE_MO = mo;
    }

    /* ======================== BOOT ======================== */

    injectCSS();
    observe();

    // Carrinho pode já estar "sujo" de uma sessão anterior (cliente comprou na
    // LP, fechou o browser e voltou pela home). Uma verificação no load resolve.
    if (document.readyState === "loading") {
      document.addEventListener("DOMContentLoaded", function () {
        enforce();
      });
    } else {
      enforce();
    }

    // Volta do bfcache (botão voltar do browser) — DOMContentLoaded não dispara.
    window.addEventListener("pageshow", function (e) {
      if (e.persisted) enforce();
    });
  } catch (e) {
    console.warn("[MINIPOTE-GUARD] fatal error:", e);
  }
})();
